import { OrganizationInfo } from '@features/onboarding/types';
import { UserProfile } from '@shared/types/user';

export interface AuthDetails {
  provider: 'email' | 'google';
  hasPassword: boolean;
  lastPasswordChange?: string;
}

export interface UpdateProfileDto {
  profile?: UserProfile;
  settings?: UserSettings;
  organization?: OrganizationInfo;
}

export interface UpdatePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export interface NotificationSettings {
  comments: boolean;
  messages: boolean;
  mentions: boolean;
  likePosts: boolean;
  connections: boolean;
  newResource: boolean;
  newSpace: boolean;
  newEvent: boolean;
  eventAttendance: boolean;
}

export enum DigestFrequency {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export interface UserSettings {
  notificationSettings: NotificationSettings;
  digestFrequency: DigestFrequency;
  language: string;
  theme: string;
}

/**
 * Base user roles for the application
 */
export enum UserRole {
  ADMIN = 'admin',
  ORGANIZATION = 'organization',
  COMPANY = 'company',
  USER = 'user',
}
